import React, { useState, useEffect } from "react";
import apiService from "../../service/apiService";
import { FormHelperText } from "@mui/material";

import {
    Box,
    Button,
    TextField,
    Typography,
    Grid,
    Paper,
    FormControl,
    InputLabel,
    Select,
    MenuItem, Autocomplete
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
const AddFarmer = () => {
    const [farmerClasses, setFarmerClasses] = useState([]);
    const navigate = useNavigate();
    const [error, setError] = useState(false);
    const [formData, setFormData] = useState({
        farmerName: '',
        farmerClass: '',
        fatherName: '',
        age: '',
        genderId: '',
        casteId: '',
        producerGroupId: '', producerGroupIds: [],
        phoneNumber: '',
        registeredDate: '',
        aadharNumber: '',
        koId: "",
        availableLand: ''
    });
    const [producerGroupList, setProducerGroupList] = useState([]);
    const [isSaveDisabled, setIsSaveDisabled] = useState(true);
    
        useEffect(() => {
          const requiredFields = [
            "farmerName",
            "farmerClass",
            "fatherName",
            "age",
            "genderId",
            "casteId",
            "producerGroupId",
            "phoneNumber",
            "registeredDate",
            "aadharNumber",
            "availableLand",
          ];
        
          const isAnyFieldEmpty = requiredFields.some(
            (field) => !formData[field] || formData[field] === 0 || formData[field] === ""
          );
        
          setIsSaveDisabled(isAnyFieldEmpty);
        }, [formData]);
    const handlePhoneNumberChange = (e) => {
        const phoneNumber = e.target.value;
        if (/^\d{0,10}$/.test(phoneNumber)) {
            setFormData({ ...formData, phoneNumber });
        }
        setError(phoneNumber.length > 10 || (phoneNumber.length === 10 && !/^\d{10}$/.test(phoneNumber)));
    };

    useEffect(() => {
        apiService.get('/farmer-classifications/get-all')
            .then(response => {
                setFarmerClasses(response.data); 
            })
            .catch(error => {
                console.error('There was an error fetching the farmer classes!', error);
            });
    }, []);
    const [genderList, setGenderList] = useState([]);
    const [casteList, setCasteList] = useState([]);
    const fetchProducerGroupData = async () => {
        try {
            const response = await apiService.get('/producer-groups/get-all');
            setProducerGroupList(response.data);
        } catch (error) {
            console.error('Error fetching producer group data:', error);
        }
    };
    const fetchCasteData = async () => {
        try {
            const response = await apiService.get('/castes/get-all');
            setCasteList(response.data);
        } catch (error) {
            console.error('Error fetching caste data:', error);
        }
    };

    const fetchAllgender = async () => {
        try {
            const response = await apiService.get('/master/get-all-gender');
            setGenderList(response.data);
        } catch (error) {
            console.error('Error fetching caste data:', error);
        }
    };
    useEffect(() => {
        fetchAllgender();
        fetchCasteData();
        fetchProducerGroupData();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;

        const updatedValue = name === "koId" ? value.toUpperCase() : value;

        setFormData((prevState) => ({
            ...prevState,
            [name]: updatedValue,
        }));
    };

    const handleSubmit = async () => {
        const isConfirmed = window.confirm("Are you sure you want to add this Farmer?");

        if (!isConfirmed) {
            return; 
        }
        if (!/^\d{10}$/.test(formData.phoneNumber)) {
            alert("Phone number must be a valid 10-digit number.");
            return;
        }
        try {
            const response = await apiService.post(
                "/farmers/create",
                {
                    farmerName: formData.farmerName,
                    farmerClassId: formData.farmerClass,
                    fatherName: formData.fatherName,
                    age: parseInt(formData.age, 10),
                    genderId: parseInt(formData.genderId, 10),
                    casteId: parseInt(formData.casteId, 10),
                    producerGroupId: parseInt(formData.producerGroupId, 10),
                    phoneNumber: formData.phoneNumber,
                    registeredDate: formData.registeredDate,
                    aadharNumber: formData.aadharNumber,
                    koId: formData.koId,
                    availableLand: parseFloat(formData.availableLand)
                }
            );
            console.log("Farmer created successfully:", response.data);
            navigate(-1); 
        } catch (error) {
            console.error("Error creating farmer:", error);
        }
    };
    const handleCancel = () => {
        navigate(-1); 
    };
    return (
        <Paper
            elevation={4}
            sx={{
                padding: 4,
                borderRadius: 0,
                height: "92vh",
                overflowY: "auto",
            }}
        >
            <div className='mx-3 mt-2 d-flex justify-content-between'>
            <h4 className='text-bold'>Add Farmer</h4>
            <p><span className='text-danger text-bold' style={{fontSize:"18px"}}>*</span> mark fields are mandetory</p>
          </div>

            <Grid container spacing={3}>
                {/* Farmer Name */}
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label={
                            <>
                              Farmer Name <span style={{ color: "red" }}>*</span>
                            </>
                          }
                        name="farmerName"
                        value={formData.farmerName}
                        onChange={handleChange}
                        variant="outlined"
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel>Farmer Class <span style={{ color: "red" }}>*</span></InputLabel>
                        <Select
                            label={
                                <>
                                  Farmer Class <span style={{ color: "red" }}>*</span>
                                </>
                              }
                            name="farmerClass"
                            value={formData.farmerClass}
                            onChange={handleChange}
                        >
                            {farmerClasses.map((classItem) => (
                                <MenuItem key={classItem.farmerClassId} value={classItem.farmerClassId}>
                                    {classItem.farmerClass}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                {/* Father's Name */}
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label={
                            <>
                              Father's Name <span style={{ color: "red" }}>*</span>
                            </>
                          }
                        name="fatherName"
                        value={formData.fatherName}
                        onChange={handleChange}
                        variant="outlined"
                    />
                </Grid>

                {/* Age */}
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label={
                            <>
                              Age <span style={{ color: "red" }}>*</span>
                            </>
                          }
                        name="age"
                        value={formData.age}
                        onChange={handleChange}
                        variant="outlined"
                        type="number"
                        inputProps={{ min: 1 }}
                    />
                </Grid>


                {/* Aadhar Number */}
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label={
                            <>
                              Aadhar Number <span style={{ color: "red" }}>*</span>
                            </>
                          }
                        name="aadharNumber"
                        value={formData.aadharNumber}
                        onChange={handleChange}
                        variant="outlined"
                        type="text"
                        inputProps={{
                            maxLength: 12, // Aadhar numbers are 12 digits long
                            pattern: "[0-9]*", // Restrict input to numbers only
                        }}
                        error={formData.aadharNumber && formData.aadharNumber.length !== 12} // Show error if the length isn't 12
                        helperText={
                            formData.aadharNumber && formData.aadharNumber.length !== 12
                                ? "Aadhar number must be 12 digits."
                                : ""
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label={
                            <>
                              KOID 
                            </>
                          }
                        name="koId"
                        value={formData.koId}
                        onChange={handleChange}
                        variant="outlined"
                        type="text"
                    />
                </Grid>


                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth margin="dense" variant="outlined" style={{ marginTop:"0px" }}>
                        <InputLabel id="caste-label">Select Gender <span style={{ color: "red" }}>*</span></InputLabel>
                        <Select
                            labelId="caste-label"
                            value={formData.genderId}
                            onChange={(e) => handleChange({ target: { name: 'genderId', value: e.target.value } })}
                            label={
                                <>
                                  Select Gender <span style={{ color: "red" }}>*</span>
                                </>
                              }
                        >
                            <MenuItem value={0} disabled>
                                Select Gender
                            </MenuItem>
                            {genderList.map((gen) => (
                                <MenuItem key={gen.genderId} value={gen.genderId}>
                                    {gen.gender} 
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                {/* Caste */}
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth margin="dense" variant="outlined" style={{ marginTop:"0px" }}>
                        <InputLabel id="caste-label">Select Caste <span style={{ color: "red" }}>*</span></InputLabel>
                        <Select
                            labelId="caste-label"
                            value={formData.casteId || ''} // Ensure casteId is correctly handled
                            onChange={(e) => handleChange({ target: { name: 'casteId', value: e.target.value } })}
                            label={
                                <>
                                  Select Caste <span style={{ color: "red" }}>*</span>
                                </>
                              }
                        >
                            <MenuItem value="" disabled>
                                Select Caste
                            </MenuItem>
                            {casteList.map((caste) => (
                                <MenuItem key={caste.casteId} value={caste.casteId}>
                                    {caste.caste} {/* Use `caste` field to display */}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                {/* Producer Group */}
                <Grid item xs={12} sm={6}>
                <Autocomplete
                    style={{marginTop:"0px"}}
                    options={producerGroupList}
                    getOptionLabel={(option) => option.pgname || ""}
                    onChange={(event, newValue) => {
                    setFormData((prev) => ({
                        ...prev,
                        producerGroupId: newValue ? newValue.producerGroupId : "",
                    }));
                    }}
                    filterOptions={(options, { inputValue }) =>
                    options.filter((option) =>
                        option.pgname.toLowerCase().includes(inputValue.toLowerCase())
                    )
                    }
                    renderOption={(props, option) => (
                    <li {...props} key={option.producerGroupId}>
                        {option.pgname}
                    </li>
                    )}
                    renderInput={(params) => (
                    <TextField
                        {...params}
                        label={
                            <>
                              Select Producer Group <span style={{ color: "red" }}>*</span>
                            </>
                          }
                        variant="outlined"
                        margin="dense"
                        style={{marginTop:"0px"}}
                        fullWidth
                    />
                    )}
                    isOptionEqualToValue={(option, value) =>
                    option.producerGroupId === value.producerGroupId
                    }
                />
                </Grid>

                {/* Phone Number */}
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label={
                            <>
                              Phone Number <span style={{ color: "red" }}>*</span>
                            </>
                          }
                        name="phoneNumber"
                        variant="outlined"
                        type="text"
                        value={formData.phoneNumber}
                        onChange={handlePhoneNumberChange}
                        inputProps={{
                            maxLength: 10, // Phone numbers should be 10 digits
                            pattern: "[0-9]*", // Restrict input to numbers only
                        }}
                        error={formData.phoneNumber && formData.phoneNumber.length !== 10} // Show error if the length isn't 10
                        helperText={
                            formData.phoneNumber && formData.phoneNumber.length !== 10
                                ? "Phone number must be 10 digits."
                                : ""
                        }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label={
                            <>
                              Available Land (Hectares) <span style={{ color: "red" }}>*</span>
                            </>
                          }
                        name="availableLand"
                        value={formData.availableLand}
                        onChange={handleChange}
                        variant="outlined"
                        type="number"
                        inputProps={{ min: 1 }}
                    />
                </Grid>
               <Grid item xs={12} sm={6}>
                <TextField
                    name="registeredDate"
                    label={
                        <>
                            Registered Date <span style={{ color: "red" }}>*</span>
                        </>
                    }
                    type="date"
                    fullWidth
                    value={formData.registeredDate || ""}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    margin="dense"
                />
                </Grid>

                <Grid item xs={12}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 2,
                            mt: 3,
                        }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            disabled={isSaveDisabled}
                            sx={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                borderRadius: "20px",
                                paddingX: 3,
                                paddingY: 0.5,
                            }}
                        >
                            Save
                        </Button>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={handleCancel}
                            sx={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                borderRadius: "20px",
                                paddingX: 3,
                                paddingY: 0.5,
                            }}
                        >
                            Cancel
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default AddFarmer;
